import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _navigator;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import MultiPostStrategy from "../libs/MultiPostStrategy";
import beaconRequest from "../requests/beacon";
var Beacon = /*#__PURE__*/function (_MultiPostStrategy) {
  _inherits(Beacon, _MultiPostStrategy);
  var _super = _createSuper(Beacon);
  function Beacon() {
    _classCallCheck(this, Beacon);
    return _super.apply(this, arguments);
  }
  _createClass(Beacon, [{
    key: "send",
    value: function send(url, data) {
      return beaconRequest(url, data);
    }
  }]);
  return Beacon;
}(MultiPostStrategy);
_defineProperty(Beacon, "supported", typeof ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.sendBeacon) === 'function');
export { Beacon as default };